<template>
  <div
    class="cpt-card-lottery-container"
    :style="{
      'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
      'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px'
    }"
  >
    <div 
      class="barrage-wrapper"
      :style="{
        backgroundColor: cc.barrage_bg || gc.main_color
      }"
    >
      <div class="big-prize-wrapper" v-if="cd.data.big_award_list.length > 0">
        <div
          class="big-prize-list" 
          ref="list" 
          :class="{ 'active': addTransition }"
          :style="{
            'color': cc.barrage_color || gc.font_color
          }"
        ></div>
      </div>
      <p 
        v-else 
        class="default-text"
        :style="{
          'color': cc.barrage_color || gc.font_color
        }"
      >暂时没有人抽到大奖</p>
    </div>
    <div
      class="main-card-content"
      :style="{
        'background-image': !cc.background_color ? `url(${gc.section_bg.top}), url(${gc.section_bg.mid}), url(${gc.section_bg.bot})` : '',
        'background-color': cc.background_color,
        'border-radius': cc.border_radius + 'px'
      }"
    >
      <!-- <template v-if="cc.show_count_down">
        <p 
          class="time-desc"
          :style="{
            'color': gc.font_color
          }"
        >{{ interval_desc }}</p>
        <p class="timer">
          {{getTimeNumber('hour', 0)}}{{getTimeNumber('hour', 1)}}
          <span class="colon">:</span>
          {{getTimeNumber('minute', 0)}}{{getTimeNumber('minute', 1)}}
          <span class="colon">:</span>
          {{getTimeNumber('second', 0)}}{{getTimeNumber('second', 1)}}
        </p>
      </template> -->
      <div class="left-time" v-if="cc.show_left_time" :style="{'color': gc.font_color}">
        活动时间：{{cc.show_left_time}}
      </div>
      <div
        class="main-card-wrapper"
        :class="{
          'round': main_card_option.open_card, 
          'anime': main_card_option.begin_anime, 
          'rare': showYellowLight
        }"
      >
        <div class="card-box">
          <div 
            class="main-card"
            :style="{
              'background': `url(${current_award.img}) no-repeat center / cover`
            }"
          ></div>
          <div 
            class="main-card-back"
            :style="{
              'background': `url(${is_gold ? cc.glod_back_bg : cc.card_back_bg}) no-repeat center / cover`
            }"
          ></div>
        </div>
        <div class="main-card-btn-box" v-if="main_card_option.show_main_card_btn">
          <div 
            class="card-btn-1" 
            @click="closeModal"
            :style="{
              'background': `url(${gc.btn_bg}) no-repeat center / cover`,
              'color': cc.btn_receive_color
            }"
          ><p>收下卡牌</p></div>
          <div 
            class="card-btn-2" 
            @click="mineCardClickHandler(undefined, current_award)"
            :style="{
              'background': `url(${gc.btn_bg}) no-repeat center / cover`,
              'color': cc.btn_task_color
            }"
          ><p>点击分享</p></div>
        </div>
        <!-- <div class="modal-back" v-if="main_card_option.open_card" @click="onClickMainCardModal"></div> -->
      </div>
      <div 
        class="lottery-block-btn" 
        :class="{
          'disabled': is_lottery_btn_disabled
        }"
        :style="{
          'background': `url(${getMainBtnBg()}) no-repeat center / 100% 100%`,
          'color': cc.btn_lottery_color,
          'opacity': !is_lottery_btn_disabled ? 1 : cc.disable_btn_bg ? 1 : .6
        }"
        @click="drawCard"
      >立即翻牌</div>
      <p
        class="lottery-desc"
        :style="{
          'color': is_gold ? cc.glod_text_color : gc.font_color
        }"
      >{{ is_gold ? cc.show_glod_text : cc.lottery_desc }}</p>
    </div>
    <div class="section-title">
      <img :src="cc.my_card_title" alt="">
    </div>
    <div 
      class="mine-card-outer"
      :style="{
        'background-image': !cc.background_color ? `url(${gc.section_bg.top}), url(${gc.section_bg.mid}), url(${gc.section_bg.bot})` : '',
        'background-color': cc.background_color,
        'border-radius': cc.border_radius + 'px'
      }"
    >
      <template v-if="cc.mask_gradient_color && cd.data.card_pool_list.length > 2">
        <div 
          class="list-mask mask-before"
          :class="{
            'hidden': !showLeftMask
          }"
          :style="{
            'background': `linear-gradient(270deg, ${cc.mask_gradient_color} 0%, ${hexToRgba(cc.mask_gradient_color, 0)} 78.85%)`
          }"
        ></div>
        <div 
          class="list-mask mask-after"
          :class="{
            'hidden': !showRightMask
          }"
          :style="{
            'background': `linear-gradient(270deg, ${cc.mask_gradient_color} 0%, ${hexToRgba(cc.mask_gradient_color, 0)} 78.85%)`
          }"
        ></div>
      </template>
      <div 
        class="mine-card-block"
        :class="{
          'scroll': current_box.all_card_count > 2
        }"
        ref="mine-card-wrapper"
        @scroll="scrollEventHandler"
      >
        <div 
          class="mine-card-list"
          :style="{
            width: 137 * current_box.all_card_count + 17 * (current_box.all_card_count - 1) + 36 + 'px'
          }"
          ref="mine-card-list"
        >
          <div 
            class="mine-card-item" 
            v-for="index in current_box.all_card_count" 
            :key="index"
          >
            <div class="card-item-wrapper">
              <div 
                class="main-card" 
                :class="{'disabled': !cd.data.my_card_list[index - 1]}"
                :style="{
                  'background': `url(${ cd.data.my_card_list[index - 1] ? cd.data.my_card_list[index - 1].img : cc.card_back_bg}) no-repeat center / cover`
                }"
              ></div>
            </div>
            <div 
              class="card-btn-1" 
              :class="{
                'disabled': !cd.data.my_card_list[index - 1] && !undone_task[index - 1]
              }"
              :style="{
                'background': `url(${ gc.modal_confirm_btn_small }) no-repeat center / 100% 100%`,
                'color': undone_task[index - 1] ? cc.btn_task_color : cc.btn_receive_color
              }"
              @click="mineCardClickHandler(undone_task[index - 1], cd.data.my_card_list[index - 1])"
            >
              <p>{{ undone_task[index - 1] ? undone_task[index - 1].btn_text : '点击分享' }}</p>
            </div>
          </div>
        </div>
        
      </div>
      <div class="mine-card-desc" v-if="cc.mine_card_desc" :style="{ 'color': gc.font_color }">{{ cc.mine_card_desc }}</div>
    </div>
    <Modal :opacity="0.8" ref="modal" :clickMaskClose="false"></Modal>
  </div>
</template>

<script>
import { ComponentCommonMixin } from '../mixin';
import { showMessage, formatWebpParams, webpFormat } from '_lib/utils'
import Modal from '_com/Modal'
import { openBox } from '_api/activity-common-template'
import TaskMixin from '../mixins/task'

export default {
  mixins: [ComponentCommonMixin, TaskMixin],
  data () {
    return {
      showYellowLight: true,
      main_card_option: {
        begin_anime: false,
        show_main_card_btn: false,
        open_card: false
      },
      index: 0,
      addTransition: false,
      current_award: {
        img: ''
      },
      scrollLeft: 0,
      scrollListWidth: 10,
      scrollWrapperWidth: 0
    }
  },
  computed: {
    showLeftMask () {
      return this.scrollLeft > 5
    },
    showRightMask () {
      return this.scrollLeft + this.scrollWrapperWidth + 5 < this.scrollListWidth
    },
    barrage_list () {
      return this.cd.data.big_award_list
    },
    interval () {
      return this.gd.left_time
    },
    interval_desc () {
      if (this.gd.left_type == 0) { //未开始 or 已开始
        return '距离活动开始还有：'
      } else if(this.gd.left_type == 1) {
        return '距离活动结束仅剩：'
      } 
      return '该活动已结束'
    },
    task_done_count () {
      let count = 0
      this.cd.data.card_pool_list.forEach((card) => {
        let undoneTask = card.task_list.find((task) => {
          return task.state != 1
        })
        if (!undoneTask) {
          count++
        }
      })
      console.log(count);
      return count
    },
    is_lottery_btn_disabled () {
      return this.cd.data.card_pool_list.filter(item => item.left > 0).length == 0
      // return this.task_done_count === this.cd.data.my_card_list.length
    },
    undone_task () {
      let states = []
      this.cd.data.card_pool_list.forEach((card) => {
        states.push(card.task_list.find((task) => {
          return task.state != 1
        }))
      })
      return states
    },
    current_box () {
      return this.cd.data.card_pool_list[0]
    },
    is_gold () {
      if (!this.cd || !this.cc.show_glod_num) {
        return false
      }
      return (this.task_done_count >= this.cc.show_glod_num) && (this.cd.data.my_card_list.length >= this.cc.show_glod_num)
    },
  },
  created () {
    webpFormat({}).then(() => {
      this.formatWebpParams()
    })
    this.current_award.img = this.cc.card_back_bg
    this.initialCountDown()
  },
  mounted () {
    this.getAnimateProperty()
    this.initialBarrage()
  },
  watch: {
    interval () {
      this.seconds = this.interval
    }
  },
  methods: {
    getMainBtnBg () {
      if (this.is_lottery_btn_disabled && this.cc.disable_btn_bg) {
        return this.cc.disable_btn_bg
      }
      return (this.is_gold ? this.cc.show_glod_btn_bg || (this.cc.btn_bg || this.gc.btn_bg) : (this.cc.btn_bg || this.gc.btn_bg))
    },
    scrollEventHandler ({ target }) {
      this.scrollLeft = target.scrollLeft
      this.scrollListWidth = this.$refs['mine-card-list'].clientWidth
      this.scrollWrapperWidth = target.clientWidth
    },
    formatWebpParams () {
      this.$set(this.cc, 'card_back_bg', formatWebpParams(this.cc.card_back_bg))
      this.$set(this.cc, 'my_card_title', formatWebpParams(this.cc.my_card_title))
      this.$set(this.cc, 'screenshot_bg_image', formatWebpParams(this.cc.screenshot_bg_image))

      this.cd.data.my_card_list = this.cd.data.my_card_list.map((card) => {
        card.img = formatWebpParams(card.img)
        return card
      })
      this.cd.data.share_award_list = this.cd.data.share_award_list.map((card) => {
        card.img = formatWebpParams(card.img)
        return card
      })
    },
    mineCardClickHandler (task, card) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      // 分享任务走截图分享，其他任务还是走任务的逻辑
      if (task && task.task_type != 5) {
        this.taskHandler(task, this.act_id)
      } else {
        // 分享任务替换成截图分享，回来需要轮询任务完成情况
        if (task && task.task_type == 5) {
          this.$parent.jump_from_task_ids = task.task_id
          this.$parent.jump_from_act_id = this.act_id
        }
        if (card) {
          this.setScreenShot(card)
          setTimeout(() => {
            this.onClickDirectShare()
          }, 0)
        } else {
          showMessage('failed', '还没有翻牌')
        }
      }
    },
    onClickDirectShare () {
      this.closeModal()
      setTimeout(() => {
        this.$root.onScreenShot()
      })
    },
		setScreenShot (card) {
			this.$root.setScreenShot({
				component_name: 'shot-luck-card',
				component_config: {
					screen_shot_bg: this.cc.screenshot_bg_image,
					user_info: this.gd.user_info,
          share_title: this.gc.share_title,
          share_desc: this.gc.share_desc,
          share_content_desc: '刚刚抽到了' + card.name,
          share_content_color: this.cc.share_content_color,
          share_card_img: this.cc.share_card_img || card.img,
          share_prize_desc: this.cc.share_prize_desc,
          share_prize_desc_color: this.cc.share_prize_desc_color,
          share_prize_area_bg: this.cc.share_prize_area_bg,
          prize_list: this.cd.data.share_award_list
				}
			})
		},
    drawCard ({ target }) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      // this.testDrawCard(target)
      // return 

      if (this.is_lottery_btn_disabled) {
        return
      }
      if (this.lottery_lock) {
        return
      }
      this.lottery_lock = true

      openBox({
        heybox_id: this.querys.heybox_id,
        act_id: this.act_id || this.querys.act_id,
        box_machine_id: this.current_box.box_machine_id,
        task_os_type: this.querys.task_os_type,
        client_version: this.querys.version
      }).then((res) => {
        this.lottery_lock = false
        if (res.data.status == 'ok') {
          const data = res.data.result

          if (data.type == 'front_task_error') {
            showMessage('failed', '前置任务未完成')
          } else {
            data.award_list = data.award_list.map((item) => {
              item.img = formatWebpParams(item.img_url)
              return item
            })
            this.cd.data.my_card_list.push(...data.award_list)
            this.current_award = data.award_list[0]

            setTimeout(() => {
              window.scrollTo(0, this.getModalScrollTop(target) - 500)
              this.main_card_option.open_card = true
              this.main_card_option.begin_anime = true
              this.$refs['modal'].showModal()
            })
            setTimeout(() => {
              this.$parent.reload()
            }, 200)
            
            this.card_timer = setTimeout(() => {
              this.main_card_option.show_main_card_btn = true
              this.card_timer = null
              // this.card_list.push(award)
            }, 1110)
          }
        } else {
          showMessage('failed', res.data.msg)
        }
      })
    },
    testDrawCard (target) {
      this.current_award = {
        img: 'https://imgheybox.max-c.com/oa/2023/04/06/f70a846c7b62816cd538590473e5f4f6.png'
      }
      setTimeout(() => {
        window.scrollTo(0, this.getModalScrollTop(target) - 500)
        this.main_card_option.open_card = true
        this.main_card_option.begin_anime = true
        this.$refs['modal'].showModal()
      })
      // this.main_card_option.open_card = true
      // this.main_card_option.begin_anime = true
      // this.$refs['modal'].showModal()
      this.card_timer = setTimeout(() => {
        this.main_card_option.show_main_card_btn = true
        this.card_timer = null
      }, 1100)
    },
    getModalScrollTop (target) {
      if (this.modal_top) return this.modal_top
      let height = 0
      let el = target
      while (el.tagName != 'BODY') {
        height += el.offsetTop
        el = el.offsetParent
      }

      this.modal_top = height
      return this.modal_top
    },
    closeModal () {
      this.main_card_option.open_card = false
      this.main_card_option.begin_anime = false
      this.main_card_option.show_main_card_btn = false
      if (this.$refs['modal'].show) {
        this.$refs['modal'].hideModal()
      }
    },
    initialBarrage() {
      if (this.barrage_list.length > 3) {
        for (let i = 0; i < 3; i++) {
          this.$refs['list'].appendChild(this.createBarrageItem(i))
          this.index++
        }
        this.initialScroll()
      } else if (this.barrage_list.length > 0) {
        this.$refs['list'].appendChild(this.createBarrageItem(0))
      }
    },
    initialScroll() {
      this._barrage_timer_ = setInterval(() => {
        if (this.index >= this.barrage_list.length) {
          this.index = 0
        }
        this.$refs['list'].appendChild(this.createBarrageItem(this.index))
        this.index++
        this.addTransition = !this.addTransition
        setTimeout(() => {
          this.$refs['list'].style[this._transform] = 'translateY(-28px)'
        }, 300)
        setTimeout(() => {
          this.addTransition = !this.addTransition
        }, 700)
        setTimeout(() => {
          this.$refs['list'].style[this._transform] = 'translateY(0)'
          if (document.querySelectorAll('.barrage-item').length > 3) {
            this.$refs['list'].removeChild(document.querySelector('.barrage-item'))
          }
        }, 750)
      }, 3500)
    },
    createBarrageItem(index) {
      var dom = document.createElement('div')
      dom.className = 'barrage-item'
      dom.innerHTML = `<p class="start">恭喜</p><p class="nickname">${this.barrage_list[index].username}</p><p class="desc">获得 ${this.barrage_list[index].name}</p>`
      return dom
    },
    getAnimateProperty() {
      var el = document.createElement('p')
      var transforms = ['transform', 'oTransform', 'msTransform', 'mozTransform', 'webkitTransform']
      for (let key in transforms) {
        if (transforms[key] in el.style) {
          this._transform = transforms[key]
          break;
        }
      }
    },
    getTimeNumber (type, index) {
      var seconds = this.seconds % 60
      var minutes = Math.floor(this.seconds / 60) % 60
      var hours = Math.floor(Math.floor(this.seconds / 60) / 60)

      var num = 0
      switch (type) {
        case 'hour':
          if (index == 1) {
            num = hours%10
          } else if (index == 0) {
            num = Math.floor(hours/10)
          }
          break;
        case 'minute':
          if (index == 1) {
            num = minutes%10
          } else if (index == 0) {
            num = Math.floor(minutes/10)
          }
          break;
        case 'second':
          if (index == 1) {
            num = seconds%10
          } else if (index == 0) {
            num = Math.floor(seconds/10)
          }
      }
      return num
    },
    initialCountDown () {
      clearInterval(this.timer)
      this.seconds = this.interval
      this.timer = setInterval(() => {
        this.seconds--
        if (this.seconds == 0) {
          if (this.state_d == 1) {
            this.state_d = 2
          }
        }
      }, 1000)
    }
  },
  components: {
    Modal
  }
}
</script>

<style lang="less" scoped>
.big-prize-wrapper {
  width: 100%;
  max-height: 84px;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  .big-prize-list {
    width: 100%;
    height: 100%;
    padding: 0;
    overflow: hidden;
    &.active {
      transition: transform .25s linear;
    }
    /deep/ .barrage-item {
      width: 100%;
      height: 28px;
      padding: 0 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      .desc {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .start {
        width: 24px;
        white-space: nowrap;
        flex-shrink: 0;
      }
      .nickname {
        flex-shrink: 0;
        margin: 0 8px;
      }
    }
  }
}
.cpt-card-lottery-container {
  margin: 30px 14px 0;
  .main-card-content {
    padding: 21px 14px 14px;
    margin-top: 15px;
    background-size: 100% 30px, 100% calc(100% - 60px), 100% 30px;
    background-repeat: no-repeat;
    background-position: center top, center center, center bottom;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
    .time-desc {
      margin-top: 8px;
      font-size: 11px;
      line-height: 15px;
    }
    .left-time {
      position: absolute;
      top: 15px;
      left: 10px;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      color: #A4C0FF;
    }
    .timer {
      display: inline-flex;
      align-items: center;
      margin-top: 2px;
      font-size: 17px;
      font-weight: 700;
      font-family: 'Helvetica';
      line-height: 29px;
      color: #FFFFFF;
      letter-spacing: 3px;
      span {
        margin: -3px 11px 0;
        font-family: 'PingFang SC';
      }
    }
    .main-card-wrapper {
      position: relative;
      width: 181px;
      height: 246px;
      margin-top: 40px;
      &::after {
        content: '';
        position: absolute;
        left: calc(50% - 201px);
        top: calc(50% - 201px);
        width: 402px;
        height: 405px;
        z-index: 3;
        background: radial-gradient(rgba(205, 231, 255, 1) 0%, rgba(205, 231, 255, 0) 60%);
        filter: blur(32px);
        transform: scale(0);
      }
      &::before {
        content: '';
        position: absolute;
        left: calc(50% - 201px);
        top: calc(50% - 202px);
        width: 402px;
        height: 405px;
        z-index: 1;
        background: left top / 100% 100% url(https://imgheybox.max-c.com/oa/2023/04/18/61a95696cf653a41f36642753b0da56a.png);
        animation: around 15s linear 0s infinite;
        opacity: 0.8;
        pointer-events: none;
      }
      @keyframes round_back {
        0% {
          transform: rotateY(0deg);
        } 
        100% {
          transform: rotateY(-540deg);
          // opacity: 0;
        }
      }
      @keyframes round {
        0% {
          transform: rotateY(-180deg);
        } 
        100% {
          transform: rotateY(-720deg);
        }
      }
      @keyframes around {
        0% {
          transform: rotate(0);
        }
        100% {
          transform: rotate(360deg) scale(1);
        }
      }
      &.rare {
        &::after {
          background: radial-gradient(rgba(255, 241, 205, 1) 0%, rgba(255, 241, 205, 0) 60%);
        }
      }
      &.end {
        &::before {
          opacity: 0;
        }
      }
      &.round {
        z-index: 1005;
        // transform: scale(1.4);
        &::after {
          transform: scale(1);
        }
        &::before {
          opacity: 0.4;
        }
        .card-box {
          .main-card {
            opacity: 1;
          }
          .main-card-back {
            transform: rotateY(-540deg);
            opacity: 0;
          }
        }
      }
      &.anime {
        transition: transform 0.5s linear 0.6s;
        &::after {
          transition: transform 0.5s linear 0.3s;
        }
        &::before {
          transition: opacity 0.5s linear 0.3s;
        } 
        .card-box {
          .main-card {
            transition: opacity 0.3s linear 0.6s;
          }
          .main-card-back {
            animation: round_back 0.6s cubic-bezier(0.25, 0.1, 0.25, 1) 0s 1; 
            transition: opacity 0s linear 0.6s;
          }
        }
      }
      .modal-back {
        position: absolute;
        top: -50vh;
        left: -50vw;
        width: 150vw;
        height: 150vh;
        z-index: 1;
      }
      .card-box {
        position: relative;
        perspective: 1000px;
        width: 100%;
        height: 100%;
        z-index: 2;
        transform: translateZ(0);
        .main-card {
          width: 100%;
          height: 100%;
          border-radius: 9px;
          background-size: 100% 100%;
          position: relative;
          opacity: 0;
          background-color: #FF0000;
        }
        .main-card-back {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          // backface-visibility:hidden;
          // -webkit-backface-visibility: hidden;
          background-size: 100% 100%;
          transform: rotateY(0deg);
          border-radius: 9px;
        }
      }
      .main-card-btn-box {
        position: absolute;
        top: calc(100% + 30px);
        left: 50%;
        display: flex;
        align-items: center;
        // transform: translate(-50%, 0) scale(0.7143);
        transform: translate(-50%, 0);
        z-index: 5;
        .card-btn-1, .card-btn-2 {
          width: 150px;
          height: 37px;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          p {
            line-height: 21px;
            font-size: 15px;
            font-weight: 700;
          }
        }
        .card-btn-2 {
          margin-left: 15px;
        }
      }
    }
    .lottery-block-btn {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 44px;
      margin-top: 15px;
      font-weight: 700;
      font-size: 17px;
      line-height: 24px;
      letter-spacing: 1px;
      z-index: 1;
      &.disabled {
        opacity: 0.6;
        // background: #F3F4F5 !important;
        color: #8C9196 !important;
        // font-weight: 400;
      }
      img {
        width: 100%;
      }
    }
    .lottery-desc {
      margin-top: 8px;
      line-height: 15px;
      font-size: 11px;
    }
  }
  .section-title {
    margin: 30px -14px 0;
    img {
      width: 100%;
    }
  }
  .mine-card-outer {
    height: 296px;
    margin-top: 5px;
    background-size: 100% 30px, 100% calc(100% - 60px), 100% 30px;
    background-repeat: no-repeat;
    background-position: center top, center center, center bottom;
    position: relative;
    overflow: hidden;
    .list-mask {
      width: 47px;
      height: 100%;
      position: absolute;
      top: 0;
      opacity: 0.4;
      transition: opacity 0.25s cubic-bezier(0.25, 0.1, 0.25, 1);
      &.hidden {
        opacity: 0;
      }
      &.mask-before {
        left: 0;
        transform: rotate(180deg);
      }
      &.mask-after {
        right: 0;
      }
    }
    .mine-card-desc {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 14px;
      font-weight: 500;
      font-size: 11px;
      line-height: 15px;
      margin-top: 7px;
      text-align: center;
      white-space: nowrap;
    }
  }
  .mine-card-block {
    padding: 30px 0 50px;
    position: relative;
    &.scroll {
      overflow-x: auto;
      overflow-y: hidden;
    }
    .mine-card-list {
      padding: 0 18px;
      margin: 0 auto;
      display: flex;
    }
    .mine-card-item {
      width: 137px;
      & + .mine-card-item {
        margin-left: 17px;
      }
      .card-item-wrapper {
        width: 100%;
        height: 186px;
        .main-card {
          width: 100%;
          height: 100%;
          &.disabled {
            opacity: 0.6;
          }
        }
      }
      .card-btn-1, .card-btn-2 {
        width: 100%;
        height: 33px;
        margin-top: 10px;
        border-radius: 17px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.disabled {
          opacity: 0.6;
          // background: #F3F4F5 !important;
          color: #8C9196 !important;
          // font-weight: 400;
        }
        p {
          line-height: 20px;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
  }
  .barrage-wrapper {
    height: 28px;
    padding: 0 12px;
    margin: 0 14px;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    .default-text {
      line-height: 16px;
      font-size: 12px;
    }
  }
}
</style>